import { render, staticRenderFns } from "./UserPermissionForm.vue?vue&type=template&id=49a32c9e&"
import script from "./UserPermissionForm.vue?vue&type=script&lang=ts&"
export * from "./UserPermissionForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserPermissionForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports